// usePostalCodeValidation is not a "true" hook,
// and validatePostalCode function which is returned by this hook is not stable
// so it should not be called as a hook. Instead, use the exported function from this file
import { usePostalCodeValidation as getValidatePostalCodeFunction } from "postal-code-checker"

const { validatePostalCode } = getValidatePostalCodeFunction()

export { validatePostalCode }
